import { useEffect, useMemo } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { checkIsActive, reInitMenu } from '../helpers'
import {
  ThemeModeProvider,
} from '../partials'
import { Content } from './components/content'
import { FooterWrapper } from './components/footer'
import { HeaderWrapper } from './components/header'
import { MobileBottomNav } from './components/mobile-bottom-nav/MobileBottomNav'
import { ScrollTop } from './components/scroll-top'
import { Sidebar } from './components/sidebar'
import { PageDataProvider } from './core'
import { LicencaAviso } from '../../app/modules/apps/renovacao/LicencaAviso'
import { LicencaProvider, useLicenca } from '../../app/modules/apps/renovacao/LicencaContext'
import { ToolbarWrapper } from './components/toolbar'

// licença vencida: só a tela de renovação fica acessível
const ConteudoLicenciado = () => {
  const { licenca, carregando } = useLicenca()
  const { pathname } = useLocation()
  const isRenovacaoPage = useMemo(() => checkIsActive(pathname, '/renovacao'), [pathname])

  if (carregando) return null

  if (licenca?.b_vencida && !isRenovacaoPage) {
    return <Navigate to='/renovacao' replace />
  }
  return <Outlet />
}

const MasterLayout = () => {
  const location = useLocation()
  
  useEffect(() => {
    reInitMenu()
  }, [location.key])

  return (
    <PageDataProvider>
      <LicencaProvider>
      <ThemeModeProvider>
        <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
          <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
            <HeaderWrapper />
            <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
              <Sidebar />
              <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                <div className='d-flex flex-column flex-column-fluid'>
                  <LicencaAviso />
                  <Content>
                    <ConteudoLicenciado />
                  </Content>
                </div>
                <FooterWrapper />
                <MobileBottomNav />
              </div>
            </div>
          </div>
        </div>
        <ScrollTop />
      </ThemeModeProvider>
      </LicencaProvider>
    </PageDataProvider>
  )
}

export { MasterLayout }

